import { inject, Injectable } from '@angular/core';
import { NotificationsActions } from '@dice/app/store/notifications/notifications.actions';
import {
  ProfileNotification,
  ProfileNotificationAnomalyContent,
  ProfileNotificationType,
} from '@dice/app/types/notification.types';
import { Store } from '@ngxs/store';
import { StateService } from '@uirouter/core';

@Injectable({
  providedIn: 'root',
})
export class NotificationsUtilService {
  private stateService = inject(StateService);
  private store = inject(Store);

  private readonly BUDA_STATE: string = 'dice.buda.businessunit';

  private readonly DASHBOARD_NAME: string = 'anomaly_detection';

  navigateToNotificationContent(notification: ProfileNotification): void {
    if (notification) {
      const { type } = notification;
      switch (type) {
        default:
          break;
        case ProfileNotificationType.ANOMALY:
          this.navigateToAnomalyNotification(notification);
          break;
      }
    }
  }

  private navigateToAnomalyNotification(notification: ProfileNotification): void {
    const { businessUnit, anomalyId } = notification.content as ProfileNotificationAnomalyContent;
    this.store.dispatch(new NotificationsActions.SetNotificationId(anomalyId));
    const params = {
      businessUnit,
      dashboard: this.DASHBOARD_NAME,
    };
    this.stateService.go(this.BUDA_STATE, params).then(() => {
      this.store.dispatch(new NotificationsActions.DeleteUserNotification(notification));
    });
  }
}
